import apiClient from "../../../service/apiClient";
import { ADMIN_EMAIL_ENDPOINTS } from "../../../app/apiEndpoints";

export const getUpcomingEmails = (emailStatus = "2,5") => {
  return apiClient.get(`${ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_BY_STATUS}/${emailStatus}`);
};


export const updateUpcomingEmailStatus = (emailId, status, userid, isAttachment = false) => {
  return apiClient.get(`${ADMIN_EMAIL_ENDPOINTS.UPDATE_EMAIL_STATUS}/${emailId},${status},${userid},${isAttachment}`);
};

export const deleteUpcomingEmail = (emailId) => {
  return apiClient.get(`${ADMIN_EMAIL_ENDPOINTS.DELETE_EMAIL}/${emailId}`);
};

//Draft Tab EP


export const getDraftEmails = (emailStatus = "1") => {
  return apiClient.get(
    `${ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_BY_STATUS}/${emailStatus}`
  );
};

export const getDraftEmail = (emailId, templateId = null) => {
  return apiClient.get(ADMIN_EMAIL_ENDPOINTS.GET_DRAFT_EMAIL, {
    params: { emailId, templateId },
  });
};

export const updateDraftEmail = (payload) => {
  return apiClient.post(ADMIN_EMAIL_ENDPOINTS.UPDATE_DRAFT_EMAIL, payload);
};

export const updateDraftEmailStatus = (emailId, status, userid, isAttachment = false) => {
  return apiClient.get(`${ADMIN_EMAIL_ENDPOINTS.UPDATE_EMAIL_STATUS}/${emailId},${status},${userid},${isAttachment}`);
};

export const deleteDraftEmail = (emailId) => {
  return apiClient.get(`${ADMIN_EMAIL_ENDPOINTS.DELETE_EMAIL}/${emailId}`);
};

export const getEmailTemplateList = () => {
  return apiClient.get(ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_TEMPLATE_LIST);
};

export const getEmailTemplateTypes = () => {
  return apiClient.get(ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_TEMPLATE_TYPES);
};

export const getEmailTemplateFields = () => {
  return apiClient.get(ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_TEMPLATE_FIELDS);
};

export const getTemplateAttachments = (attachmentType = 1, attachmentId = 0, templateId = 0) => {
  return apiClient.get(ADMIN_EMAIL_ENDPOINTS.GET_TEMPLATE_ATTACHMENTS, {
    params: { attachmentType, attachmentId, templateId },
  });
};


//History EP

export const getEmailHistory = (emailStatus = "4") => {
  return apiClient.get(
    `${ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_BY_STATUS}/${emailStatus}`
  );
};


export const previewDraftEmail = (emailId, templateBody) => {
  return apiClient.post(
    ADMIN_EMAIL_ENDPOINTS.PREVIEW_DRAFT_EMAIL,
    { emailId, templateBody: templateBody || "" },
    { headers: { "Content-Type": "application/json" } }
  );
};


export const getEmailInfo = (emailId = "133") => {
  return apiClient.get(`${ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_INFO}/${emailId}`);
};


export const getDraftEmailHistory = (emailId= '133', templateId = null) => {
  return apiClient.get(ADMIN_EMAIL_ENDPOINTS.GET_DRAFT_EMAIL, {
    params: { emailId, templateId },
  });
};


export const insertOrUpdateEmailTemplate = (payload) => {
  return apiClient.post(ADMIN_EMAIL_ENDPOINTS.INSERT_OR_UPDATE_EMAIL_TEMPLATE, payload);
};

export const insertTemplateAttachments = (payload) => {
  return apiClient.post(ADMIN_EMAIL_ENDPOINTS.INSERT_TEMPLATE_ATTACHMENTS, payload);
};

export const updateDefaultTemplate = (payload) => {
  return apiClient.post(ADMIN_EMAIL_ENDPOINTS.UPDATE_DEFAULT_TEMPLATE, payload);
};

export const copyAndSaveEmailTemplate = (payload) => {
  return apiClient.post(ADMIN_EMAIL_ENDPOINTS.COPY_AND_SAVE_EMAIL_TEMPLATE, payload);
};

export const deleteEmailTemplate = (payload) => {
  return apiClient.post(ADMIN_EMAIL_ENDPOINTS.DELETE_EMAIL_TEMPLATE, payload);
};

export const downloadEmailAttachmentContentInfo = (attachmentId) => {
  return apiClient.get(`${ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_ATTACHMENT_CONTENT_INFO}/${attachmentId}`, {
    responseType: "blob",
  });
};

export const testSendEmailTemplate = (payload) => {
  return apiClient.post(ADMIN_EMAIL_ENDPOINTS.TEST_SEND_EMAIL_TEMPLATE, payload);
};
